import {http} from "@/api/http";
import {API_URL} from "@/api/base";


export async function getProducts(company_id, query = '', filters = {}, options = {}) {
    if (query) {
        query = new URLSearchParams(query).toString()
    } else {
        query = Object.entries(filters)
            .map(([key, value]) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
            )
            .join('&');
    }
    return await http.get(
        `${API_URL}/v1/product/list?company=${company_id}&${query}`,
        options
    )
}

export async function getProductsPost(filters = {}, options = {}) {
    return await http.post(
        `${API_URL}/v1/product/list`,
        filters,
        options
    )
}

export async function deleteProduct(product_id) {
    return await http.delete(
        `${API_URL}/v1/product/${product_id}/delete`    )
}

export async function updateProduct(product_id, data) {
    return await http.put(
        `${API_URL}/v1/product/${product_id}/update`,
        data,
    )
}

export async function newProduct(data) {
    return await http.post(
        `${API_URL}/v1/product/create`,
        data,
    )
}

export async function uploadCosts(company_id, file) {
    const formData = new FormData();
    formData.append('file', file);
    return await http.post(
        `${API_URL}/v1/product/costs/update-by-excel?company_id=${company_id}`,
        formData,
        {headers: {'Content-Type': 'multipart/form-data'}},
    )
}

export async function uploadMinPrices(company_id, file) {
    const formData = new FormData();
    formData.append('file', file);
    return await http.post(
        `${API_URL}/v1/product/min-price/update-by-excel?company_id=${company_id}`,
        formData,
        {headers: {'Content-Type': 'multipart/form-data'}},
    )
}

export async function updateCosts(company_id, costs) {
    return await http.post(
        `${API_URL}/v1/product/costs/update-by-code?company_id=${company_id}`,
        costs,
    )
}

export async function updateMinPrices(company_id, minPrices) {
    return await http.post(
        `${API_URL}/v1/product/min-price/update-by-code?company_id=${company_id}`,
        minPrices,
    )
}

export async function getProductsBulkInfo(product_ids, company_id) {
    return await http.post(
        `${API_URL}/v1/product/bulk/info`,
        { "product_ids": product_ids, "company": company_id }    )
}